import { inject, Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  readonly #jwtHelper = inject(JwtHelperService);


  isValidToken(): boolean {
    const token = sessionStorage.getItem('tokenMotor');

    if (!token) return false;
    return !this.#jwtHelper.isTokenExpired(token);
  }
}
